export interface IAddress {
    address?: string;
    district?: string;
    email?: string;
    firstname?: string;
    lastname?: string;
    name?: string;
    id?: number;
    phone?: string;
    postcode?: string;
    subDistrict?: string;
    province?: string;
    location?: ILocation;
}

export class Address implements IAddress {
    address?: string;
    district?: string;
    email?: string;
    firstname?: string;
    lastname?: string;
    name?: string;
    id?: number;
    phone?: string;
    postcode?: string;
    subDistrict?: string;
    province?: string;
    location?: ILocation;

    constructor(data: IAddress) {
        this.address = data.address
        this.district = data.district
        this.email = data.email
        this.firstname = data.firstname
        this.lastname = data.lastname
        this.name = data.name
        this.id = data.id
        this.phone = data.phone
        this.postcode = data.postcode
        this.subDistrict = data.subDistrict
        this.province = data.province
        if (data.location) {
            this.location = new Location(data.location)
        }
    }

    data(): IAddress {
        return Object.assign({}, this);
    }
}

export interface ILocation {
    lat?: number;
    lng?: number;
}
export class Location implements ILocation {
    lat?: number;
    lng?: number;

    constructor(data: ILocation) {
        this.lat = data.lat
        this.lng = data.lng
    }
}